<template>
  <ion-app class="ion-app">
    <keep-alive>
      <ion-router-outlet animated="false" />
    </keep-alive>
  </ion-app>
</template>

<script>
import { IonApp, IonRouterOutlet } from '@ionic/vue';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'App',
  components: {
    IonApp,
    IonRouterOutlet
  }
});
</script>